import React, { Component } from 'react'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'
import VaultEncResUpdateCC from '../samples/VaultEncResUpdateCC'
const OBJECT = [  "encresupdatecc", "enc_res_update_cc", "encresupdatecc"]
const METHODS = { 
    SetEncTrack2:[  ".SetEncTrack2(enc_track2);", ".SetEncTrack2(enc_track2);", "'enc_track2'=>$enc_track2"],
    SetDeviceType:[  ".SetDeviceType;", ".SetDeviceType;", "'device_type'=>$device_type"],
    SetCusId: [  ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    SetAvsCheck: [  ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    SetEmail: [  ".SetEmail(email);", ".setEmail(email);", "'email'=>$email"],
    SetPhone: [  ".SetPhone(phone);", ".setPhone(phone);", "'phone'=>$phone"],
    SetNote: [  ".SetNote(note);", ".setNote(note);", "'note'=>$note"],
    SetDataKeyFormat: [  ".SetDataKeyFormat(data_key_format);", ".SetDataKeyFormat(data_key_format);", "'data_key_format'=>$data_key_format"],
    SetDataKey: [  ".setData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    CreditCardNumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    ExpiryDay: [  ".setExpdate(expiry_date);", ".setExpdate(expiry_date);", "'expdate'=>$expiry_date"],
    SetDuration: [  ".SetDuration(duration);", ".SetDuration(duration);", "'duration'=>$duration"],
    CreditCardCumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    SetCryptType: [  ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt_type'=>$crypt"],    
    setCotInfo: [  ".SetCofInfo(cof);", ".setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    SetIssueId: [  `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{$cof->setIssuerId("VALUE_FOR_ISSUER_ID");}`],
    SetOrderId: [  "SetOrderId(order_id);", "SetOrderId(order_id);", "'order_id'=>$order_id"],
    SetTxnNumber: [  "SetTxnNumber(txn_number);", "setTxnNumber(txn_number);", "'txn_number'=>$txn_number"]
}
export class VaultEncryptedUpdate extends Component {
    componentDidMount() {
        this.props.selectMode('integration_guide')
      }



    render() { 
        const { progLangId } = this.props;
        return (
            <div className="stepPageContainer">  
            <div>
            <h3 className="stepPageTitle">Vault Encrypted Update CC – EncResUpdateCC</h3>
            <p><b>Vault Encrypted Update CC transaction object definition</b></p>   
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>EncResUpdateCC encresupdatecc = new EncResUpdateCC();
                            </code>
                        case 1:
                            return <code>EncResUpdateCC enc_res_update_cc = new EncResUpdateCC();
                            </code>
                        case 2:
                            return <code>
                                {`$txnArray = array(‘type’=>’enc_res_update_cc', …);`}<br/>
                                {`$mpgTxn = new mpgTransaction($txnArray);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
            <p><b>HttpsPostRequest object for Vault Encrypted Update CC transaction</b></p>   
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();
                            </code>
                        case 1:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();

                            </code>
                        case 2:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
                   {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>mpgReq.setTransaction(enc_res_update_cc);</code>
                        case 1:
                            return <code>mpgReq.setTransaction(enc_res_update_cc);</code>
                        case 2:
                            return <code>
                                {`$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);`}
                                </code>
                        default:
                            return null
                        }
                    })()}

        

        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Encrypted Update CC transaction request fields – Required</h3>
        <p>For a full description of mandatory and optional values, see Appendix A Definition of Request Fields.</p>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>credit card number</td>
                    <td>String<br/>max 20-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.CreditCardNumber[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>(missing or bad snippet)<br /></td>
                    <td>String<br/>(missing or bad snippet)</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetEncTrack2[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>(missing or bad snippet)</td>
                    <td>String</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDeviceType[progLangId]}</code></td>
                </tr>
              
                </tbody>
            </table>

            <p>Optional values that are submitted to the ResUpdateCC object are updated, while unsubmitted optional
                values (with one exception) remain unchanged. This allows you to change only the fields you want.<br/>
                The exception is that if you are making changes to the payment type, <b>all</b> of the variables in the optional
                values table below must be submitted.<br/>
                If you update a profile to a different payment type, it is automatically deactivated and a new credit card
                profile is created and assigned to the data key. The only values from the prior profile that will remain
                unchanged are the customer ID, phone number, email address, and note.
            </p>

                            <p className="note">
                                <strong>EXAMPLE: </strong> 
                                If a profile contains AVS information, but a ResUpdateCC transaction is submitted
                                without an AVSInfo object, the existing AVSInfo details are deactivated and the new
                                credit card information is registered without AVS.
                            </p>
                        


        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Encrypted Update CC transaction request fields – Optional</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>
                    electronic commerce indicator
                    </td>
                    <td> String<br/>1-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCryptType[progLangId]}</code></td>
                </tr>  
                <tr>
                    <td>customer ID</td>
                    <td>String<br/>
                        50-character alphanumeric<br/> 
                            <p className="note">
                                <strong>NOTE: </strong> 
                                Some special characters are not
                                allowed:
                                {`< > $ % = ? ^ { } [ ] \\`}
                            </p>
                        </td>
                        <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCusId[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>email address<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetEmail[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>phone number<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetPhone[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>note</td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetNote[progLangId]}</code></td>                
                </tr>

                <tr>
                    <td>data key format</td>
                    <td>String<br/>2-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDataKeyFormat[progLangId]}</code></td>                
                </tr>
                </tbody>
            </table>

            <p><b>Vault response fields</b></p>
            <p>For a list and explanation of (Receipt object) response fields that are available after sending this Vault
                transaction, see Definitions of Response Fields.
            </p>
          </div>
          <h3>Sample EncResUpdateCC</h3>
          <VaultEncResUpdateCC/>
        </div>
        )
    }
}

const mapStateToProps = state => {
  const {mode} = state.common.sideNav;
  return { mode,progLangId: state.common.progLangList.selection};
}

export default connect(mapStateToProps, { selectMode})(VaultEncryptedUpdate)
